import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import axios from 'axios'
// var axios = window.axios
Vue.use(Vuex)
const state = {
  offers: []
}
const getters = {
  getOffers: function (state) {
    return state.offers
  }
}
const actions = {
  fetchAllOffersFromDb (context) {
    return new Promise((resolve, reject) => {
      axios
        .get('o/getOffers'
        )
        .then(response => {
          var offers = []
          if (response.data !== null && response.data !== undefined) {
            for (let i = 0; i < response.data.length; i++) {
              var expiryDate = response.data[i].validTil
              // console.log(expiryDate.substring(expiryDate.indexOf('T') + 1, expiryDate.indexOf(expiryDate.length)).split(':'))
              var expiryDateList = expiryDate.substring(0, expiryDate.indexOf('T')).split('-')
              var newDate = {
                'year': expiryDateList[0],
                'month': expiryDateList[1],
                'day': expiryDateList[2]
              }
              expiryDateList = []
              expiryDateList = expiryDate.substring(expiryDate.indexOf('T') + 1, expiryDate.length).split(':')
              newDate['hour'] = expiryDateList[0]
              newDate['min'] = expiryDateList[1]
              newDate['sec'] = expiryDateList[2].substring(0, expiryDateList[2].indexOf('+'))
              expiryDate = new Date(newDate['year'], newDate['month'], newDate['day'], newDate['hour'], newDate['min'], newDate['sec'])
              var currentDate = new Date()
                // console.log('cd', currentDate)
                // console.log('ed', expiryDate)
                // console.log((currentDate >= expiryDate))
              if (currentDate < expiryDate) {
                offers.push(response.data[i])
              }
            }
          }
          context.commit('setOffersStoreData', offers)
          resolve()
        })
        .catch(e => {
          console.log('Catch', e)
          reject(e)
        })
    })
  }
}
const mutations = {
  setOffersStoreData (state, data) {
    if (data === null) {
      state.offers = []
    } else {
      state.offers = data
    }
  },
  clearOffersStoreData (state) {
    state.offers = []
  }
}
export default {
  state,
  actions,
  getters,
  mutations,
  plugins: [createPersistedState({ storage: window.localStorage })]
}



// WEBPACK FOOTER //
// ./src/store/modules/offer.js